export enum FormType {
  WIZARD = 'QUOTE_WIZARD_FORM',
  FREE_QUOTE = 'FREE_QUOTE_FORM',
  ENROLLMENT = 'ENROLLMENT_FORM',
  PRICE_REQUEST = 'PRICE_REQUEST_FORM',
  QUICK_QUOTE_TOOL = 'QUICK_QUOTE_TOOL',
}
